import { transformSalesCartItemsRequest, transformSalesCartItemsResponse, transformGetSalesCartItemsResponse, transformSalesCartMeTotalsResponse, transformPatchSalesCartItemsResponse } from './transformers.js';
import '../../client/index.js';
import { wrapErrorManager } from '../../utils/error-manager.js';
import defaultClient from 'axios';

const postSalesCartItems = async ({ client , controller , sku , qty , bundleOptions , customOptions , configurableOptions , groupedOptions , giftcardOptions  } = {})=>await client.post(`V1/sales/cart/items`, {
        sku,
        qty,
        bundleOptions,
        customOptions,
        configurableOptions,
        groupedOptions,
        giftcardOptions
    }, {
        signal: controller?.signal,
        transformRequest: [
            transformSalesCartItemsRequest,
            ...(client || defaultClient).defaults.transformRequest
        ],
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformSalesCartItemsResponse)
        ]
    });
postSalesCartItems.key = 'postSalesCartItems';
const getSalesCartItems = async ({ client , controller  })=>{
    // TODO: to be removed when https://filoblu.atlassian.net/browse/BEEH-130 completed
    const notFountRetry = client.interceptors.response.use(null, function(error) {
        const { config , response  } = error;
        const retry = config?._retry || 0;
        if (retry < error?.config?._retry_max) {
            if (response.status === 404 && config?.method === 'get' && config?.url === `V1/sales/cart/items` && response.data?.error?.message === 'session not found') {
                try {
                    return client.get(`V1/sales/cart/items`, {
                        signal: controller?.signal,
                        transformResponse: [
                            ...client.defaults.transformResponse,
                            wrapErrorManager(transformGetSalesCartItemsResponse)
                        ],
                        _retry: retry + 1
                    });
                } catch (err) {
                    return Promise.reject(err);
                }
            }
        }
        return Promise.reject(error);
    });
    const response = await client.get(`V1/sales/cart/items`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformGetSalesCartItemsResponse)
        ]
    });
    client.interceptors.response.eject(notFountRetry);
    return response;
};
getSalesCartItems.key = 'getSalesCartItems';
const deleteSalesCartItem = async ({ client , controller , id  } = {})=>await client.delete(`V1/sales/cart/items/${id}`, {
        signal: controller?.signal
    });
deleteSalesCartItem.key = 'deleteSalesCartItem';
const deleteSalesCartItems = async ({ client , controller  } = {})=>await client.delete(`V1/sales/cart/items`, {
        signal: controller?.signal
    });
deleteSalesCartItems.key = 'deleteSalesCartItems';
const getSalesCartMeTotals = async ({ client , controller  })=>await client.get(`V1/sales/cart/me/totals`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformSalesCartMeTotalsResponse)
        ]
    });
getSalesCartMeTotals.key = 'getSalesCartMeTotals';
const patchSalesCartItems = async ({ client , controller , id , qty  } = {})=>await client.patch(`V1/sales/cart/items/${id}/qty/${qty}`, null, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformPatchSalesCartItemsResponse)
        ]
    });
patchSalesCartItems.key = 'patchSalesCartItems';

export { deleteSalesCartItem, deleteSalesCartItems, getSalesCartItems, getSalesCartMeTotals, patchSalesCartItems, postSalesCartItems };
